import styled from 'styled-components';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint, FontSize, FontWeight, LineHeight } from '../../../common/styles/constants';
import { BackgroundElement, BackgroundElementExperiment } from './BackgroundElement';
import { MobileBackgroundElement } from './MobileBackgroundElement';

export const HomeBannerPerson = styled(HeImgix)`
  bottom: 0;
  display: flex;
  height: 100%;
  position: absolute;
  right: -125px;
  width: auto;

  ${Breakpoint.HEIGHT_LARGE} {
    height: 90%;
    right: -160px;
  }
`;

export const BannerStaticWrapper = styled.div`
  bottom: 0;
  display: none;
  height: 90%;
  left: calc(50% - 618px);
  position: absolute;

  ${Breakpoint.LARGE} {
    display: flex;
  }
`;

export const BannerElementWrapper = styled.div`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
`;

export const BannerBackground = styled(BackgroundElement)`
  height: 100%;
  position: relative;
  right: -18%;
`;

export const BannerBackgroundExperiment = styled(BackgroundElementExperiment)`
  height: 100%;
  position: relative;
  right: -18%;
`;

export const MobileBannerBackground = styled(MobileBackgroundElement)`
  bottom: 5%;
  height: 100%;
  position: relative;
  width: 100%;
`;

export const HomeHeroPageSection = styled(PageSection)`
  background-color: ${ThemeColours.mono100};

  ${Breakpoint.EXTRA_LARGE} {
    height: 580px;

    ${Breakpoint.HEIGHT_LARGE} {
      height: 750px;
    }
  }
`;

export const HomeHeroPageSectionExperiment = styled(PageSection)`
  background-color: ${ThemeColours.primary400};
  height: 328px;

  ${Breakpoint.SMALL} {
    height: 580px;

    ${Breakpoint.HEIGHT_LARGE} {
      height: 750px;
    }
  }
`;

export const HomeHeroCol = styled.div`
  max-width: 670px;
`;

export const HomeHeroColExperiment = styled(HomeHeroCol)`
  margin-top: 12px;
`;

export const HomeHeroHeading = styled(Heading)`
  font-size: ${FontSize.HEADING_3};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.HEADING_3};
  margin-bottom: calc(${FontSize.REGULAR} / 1.6);

  ${Breakpoint.SMALL} {
    font-size: ${FontSize.HEADING_1};
    line-height: ${LineHeight.HEADING_1};
    margin-bottom: calc(${FontSize.HEADING_1} / 1.6);
  }
`;

export const HomeHeroSubHeading = styled(Heading)`
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.REGULAR};

  ${Breakpoint.SMALL} {
    font-size: ${FontSize.HEADING_3_SMALL};
    line-height: ${LineHeight.HEADING_3_SMALL};
  }
`;

export const HomeHeroHeadingExperiment = styled(HomeHeroHeading)`
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 8px;

  ${Breakpoint.SMALL} {
    margin-bottom: 16px;
  }
`;

export const HomeHeroSubHeadingExperiment = styled(HomeHeroSubHeading)`
  margin-bottom: 0;
`;

export const HomeHeroMobilePromptTitle = styled(Heading)`
  display: flex;
  font-weight: ${FontWeight.SEMI_BOLD};

  ${Breakpoint.SMALL} {
    display: none;
  }
`;
